/**
 * App - Aplicatoin Entry Point
 */
import AppContainer from "./AppContainer";
export default AppContainer;
